import React, { useEffect, useState } from "react";
import style from "./Blocks.module.css";
import CommonButton from "../CommonButton";
import { getBlocksAsPerLobName } from "../../Services/approval.service";
import useToaster from "../../customHook/useToaster";

const activeBlockStyle = {
  border: "0.50px #339DFF solid",
  boxShadow: " 0px 4px 4px rgba(0, 0, 0, 0.25)",
};

const Blocks = ({
  blockName = [],
  blockData = [],
  setBlockData = () => {},
}) => {
  const onClickHandler = (clickedId) => {
    setBlockData((prevBlockData) =>
      prevBlockData.map((item) =>
        item.block_master_id === clickedId
          ? { ...item, isActive: !item?.isActive }
          : item
      )
    );
  };

  const selectAllHandler = () => {
    setBlockData((prevBlockData) => {
      let isAllSelected = prevBlockData?.find((obj) => !obj?.isActive);
      return prevBlockData.map((item) => ({
        ...item,
        isActive: isAllSelected ? true : false,
      }));
    });
  };

  useEffect(() => {
    setBlockData(blockName);
  }, [blockName]);
  return (
    <div className={style["blocks_container"]}>
      {blockData?.map((item, id) => (
        <h1
          key={item?.block_master_id}
          className={style["blocks"]}
          style={item?.isActive ? { ...activeBlockStyle } : {}}
          onClick={() => onClickHandler(item?.block_master_id)}
        >
          {item?.block_name}
        </h1>
      ))}
      <div>
        <CommonButton
          label={
            blockData?.find((obj) => !obj?.isActive)
              ? "Select All"
              : "Deselect All"
          }
          isColor
          backgroundColor={"#339DFF"}
          textColor={"#FFFFFF"}
          removeBorder
          isHover
          hoverColor={"#339DFF"}
          sx={{ padding: "0.1em 1.5rem" }}
          onClick={selectAllHandler}
        />
      </div>
    </div>
  );
};

export default Blocks;
